const styles = {
    wrapper: {
        flexDirection: "column"
    }
};

export default styles;
